export default {
    AtribuicaoCargoPartidario: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "atribuicao-cargo-partidario"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/AtribuicaoCargoPartidario.js
// module id = Lcpb
// module chunks = 16